import { DataGridProps, GridPaginationModel } from '@mui/x-data-grid';
import { PaginationQuery } from '@libs/dto';

export const DEFAULT_PAGE_SIZE_OPTIONS = [15, 25, 50, 100];

export const DEFAULT_SLOT_PROPS: DataGridProps['slotProps'] = {
  loadingOverlay: {
    variant: 'skeleton',
    noRowsVariant: 'skeleton',
  },
  pagination: {
    rowsPerPageOptions: DEFAULT_PAGE_SIZE_OPTIONS,
    showFirstButton: true,
    showLastButton: true,
  },
}

export const DEFAULT_PAGINATION_MODEL: GridPaginationModel = { page: 0, pageSize: 15 };

export const DEFAULT_PAGINATION_QUERY: PaginationQuery = { q: '', page: 1, limit: 15 };